<template>
  <div id="app">
    <div :class="[
      isLoginRoute ? 'app_header_login_P' : 'app_header_noLogin_P', ,
      $isMobile ? '' : 'pl-2 pr-2',
    ]">
      <div class="d-flex align-items-center justify-content-between p-1">
        <div v-if="!$isMobile">
          <div class="logo_tab_flex">
            <div class="d-flex align-items-center justify-content-between" style="margin-right: 1.5rem;">
              <img src="@/assets/logo.png" alt="" style="width: 2rem;height: 2rem;">
              <div class="logo_span1">Ternova Market </div>
            </div>
            <div class="logo_tab">
              <div v-for="item in tabList" :key="item.id" style="font-size: 0.75rem;"
                @click="handleTab(item.id, item.path)">
                <div :class="{ 'logo_tab_font_active': item.id == type }" class="logo_tab_font">
                  {{$t(item.name)}}
                </div>
              </div>
            </div>

          </div>

        </div>

        <div @click="meauVisible = true" style="margin-right: 0.5rem;" v-if="$isMobile">
          <img src="@/assets/images/meau.png" alt="" style="margin-bottom:3px;width: 1rem;height: 1rem;" />
        </div>
        <div class="logo_lang">
          <div style="display: flex; align-items: center">
            <div @click="handleOpen" style="margin-right: 0.5rem;">
              <img class="logo_lang_img" src="@/assets/lang.png" alt="" style="margin-bottom:3px;" />
            </div>
            <div @click="handleAddress()" class="logo_Address">
              {{ isLoginState ? getAdr() : $t("连接钱包") }}
            </div>
            <!-- <div v-if="isLoginState" @click="handleKyc()" class="logo_Address">
              {{ $t("KYC认证") }}
            </div> -->

            <!-- 帮助文档，点击跳转帮助文档页面 -->
            <!-- <div style="display: flex; align-items: center; margin-left: 0.3rem" @click="getGo('/help')">
              <img class="logo_lang_img" src="@/assets/help2.png" alt="" />
            </div> -->
          </div>

        </div>


      </div>

    </div>

    <!-- 切换语言弹窗 -->
    <PopLang ref="childLang" :dialogVisible="popState" :LangLists="langArr" @handleClose="popState = false"
      @submit="handleSubmit"></PopLang>

    <PopLang :popTitle="kfcTitle" :dialogVisible="kycState" @handleClose="kycState = false" @submit="handleSubmitKyc">
      <template v-slot:bodyTitle>
        <div style="padding: 0 1rem">
          <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="60px" style="font-size: 0.75rem">
            <div class="popStyle_inp">
              <el-form-item :label="$t('姓名')" prop="name">
                <el-input v-model="ruleForm.name" :placeholder="$t('姓名')"></el-input>
              </el-form-item>
            </div>
            <div class="popStyle_inp">
              <el-form-item :label="$t('国籍')" prop="guoji">
                <el-input v-model="ruleForm.guoji" :placeholder="$t('国籍')"></el-input>
              </el-form-item>
            </div>
            <div class="popStyle_inp">
              <el-form-item :label="$t('电话')" prop="phone">
                <el-input v-model="ruleForm.phone" :placeholder="$t('电话')"></el-input>
              </el-form-item>
            </div>
            <div class="popStyle_inp">
              <el-form-item :label="$t('邮箱')" prop="email">
                <el-input v-model="ruleForm.email" :placeholder="$t('邮箱')"></el-input>
              </el-form-item>
            </div>
            <div class="popStyle_inp">
              <el-form-item :label="$t('所在区域')" prop="area">
                <el-input v-model="ruleForm.area" :placeholder="$t('所在区域')"></el-input>
              </el-form-item>
            </div>

            <div class="popStyle_inp">
              <el-form-item :label="$t('其他')">
                <el-input v-model="ruleForm.remark" :placeholder="$t('其他')"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </template>
    </PopLang>
    <div :class="[$isMobile ? 'app_M' : isPcRoute ? 'app_Ps' : 'app_P']">
      <router-view />
    </div>
    <Footer v-if="stylesLoaded" />
    <el-drawer :visible.sync="meauVisible" size="40%" :with-header="false" direction="ltr">
      <div style="flex-direction: column;">
        <div class="logo_tab_end_draw">

          <img src="@/assets/images/cha.png" @click="meauVisible = false" alt=""
            style="width: 1rem;height: 1rem; margin: 0.5rem 1rem 0px 1rem;">
        </div>
        <div v-for="item in tabList" :key="item.id" style="font-size: 0.75rem; margin-top: 1rem;"
          @click="handleTab(item.id, item.path)">
          <div :class="{ 'logo_tab_font_active': item.id == type }" class="logo_tab_font">
            {{ item.name }}
          </div>
        </div>
      </div>

    </el-drawer>

  </div>
</template>

<script>
import Footer from "@/components/Footer/index.vue";
import { toKycSubmit, toKycShow, toFooterConfigs } from "@/api/index.js";
import { getChain, connectWallet } from "@/utils/index.js";
import { setRem, langList, toolAddr } from "@/utils/utils";
export default {
  name: "App",
  components: {
    Footer,
  },
  data() {
    return {

      inviteCode: '',
      stylesLoaded: false,
      meauVisible: false,
      tabList: [{
        id: 1,
        name: "首页",
        path: "/",
      }, {
        id: 2,
        name: "运作方式",
        path: "/operation",
      }, {
        id: 3,
        name: "项目",
        path: "/project",
      }, {
        id: 4,
        name: "合伙人社区",
        path: "/partner",
      },
      //  {
      //   id: 5,
      //   name: "为什么选择Ternova",
      // },
      {
        id: 6,
        name: "启动应用",
        path: "link",
      }],
      type: 1,
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        guoji: [{ required: true, message: "请输入国籍", trigger: "blur" }],
        phone: [{ required: true, message: "请输入电话", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        area: [{ required: true, message: "请输入所在区域", trigger: "blur" }],
      },
      ruleForm: {
        name: "",
        guoji: "",
        phone: "",
        email: "",
        area: "",
        remark: "",
      },
      // 审核状态  0 审核 1 通过 2 驳回
      kycI: 3,
      kycState: false,
      popState: false,
      isLoginRoute: this.$route.path === "/login",
      isPcRoute:
        this.$route.path === "/partner" || this.$route.path === "/mycommuntiy",
      activeTab: sessionStorage.getItem("active") || null,
    };
  },
  watch: {
    // 监听路由变化
    "$route.path"(newPath) {
      this.isLoginRoute = newPath === "/login";
      this.isPcRoute = newPath === "/partner" || newPath === "/mycommuntiy";
      this.type = newPath == '/project' ? 3 : newPath == '/operation' ? 2 : newPath == '/partner' ? 4 : newPath == '/' ? 1 : 5
    },

  },
  computed: {
    // 是否登录
    isLoginState() {
      let p = this.$store.state.isLoginState;

      return !!p;
    },
    kfcTitle() {
      if (this.kycI == 2) {
        return "KYC认证";
      } else if (this.kycI == 0) {
        return "KYC认证(审核中)";
      } else if (this.kycI == 1) {
        return "KYC认证(审核通过)";
      }
    },
    tokenState() {
      return sessionStorage.getItem("token");
    },
    checkUserBind() {
      return this.$store.state.show;
    },
    langArr() {
      return langList.Lang;
    },
    isFullscreen() {
      return this.$store.state.fullScreen;
    },
    loginAddr() {
      return this.$store.state.address;
    },
  },
  mounted() {

    this.type = sessionStorage.getItem("active") || 1;
    if (!this.tokenState) {
      this.$store.commit("SET_ClEAR");
    }
    this.getAdapter();
    setTimeout(() => {
      this.getChains();
      this.stylesLoaded = true
      this.inviteCode = this.$route.query.i || '';

    }, 1000);
    let p = this.$store.state.isLand || "zh";
    this.$i18n.locale = p;
    this.getLink();

    // this.getKFCShow();
  },

  methods: {
    getLink() {
      toFooterConfigs()
        .then((res) => {

          this.link = res.data.lianjie1;
        })
        .catch((e) => { });
    },
    handleTab(a, b) {
      this.type = a;

      this.meauVisible = false;
      if (b != "link") {
        sessionStorage.setItem("active", a);
        this.getGo(b);
      } else {
        window.open(this.link, "_blank");
      }


    },
    getGo(a) {
      if (a == this.$route.path) {
        return;
      }
      this.$router.push({ path: a });
    },
    getKFCShow() {
      if (!this.isLoginState) return;
      toKycShow()
        .then((res) => {
          let d = res.data;
          this.kycI = d.status;
          this.ruleForm = {
            name: d.real_name,
            area: d.area,
            email: d.email,
            guoji: d.guoji,
            phone: d.phone,
            remark: d.remark,
          };
        })
        .catch((e) => { });
    },
    handleSubmitKyc(formName = "ruleForm") {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          toKycSubmit(this.ruleForm)
            .then((res) => {
              this.kycState = false;
              this.ruleForm = {
                name: "",
                guoji: "",
                phone: "",
                email: "",
                area: "",
                remark: "",
              };
              this.$toast(res.msg);
            })
            .catch((e) => { });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleKyc() {
      this.kycState = true;
      this.getKFCShow();
    },
    getAdr() {
      return toolAddr(this.loginAddr);
    },
    // 连接钱包
    async handleAddress() {
      let p = await getChain();
      if (p) {
        this.$store.commit("SET_INVITECODE", this.inviteCode);
        if (this.tokenState) {
          // this.$router.push("/");
        } else {

          this.$store.dispatch("loginStore");

        }
      } else {
        this.$toast(this.$t("请切换到天晟链"));
      }
    },


    handleOpen() {
      this.$refs.childLang.getInit();
      this.popState = true;
    },
    handleSubmit(a) {
      let arr = this.langArr.filter((item) => item.id == a);
      if (arr.length > 0) {
        console.log(arr[0].value, "arr");
        this.$store.commit("SET_ISLANGD", arr[0].value);
        this.$i18n.locale = arr[0].value;
        localStorage.setItem("SET_LANGUAGE", arr[0].value);
        this.popState = false;
        window.location.reload();
      }
    },
    // 判断链
    async getChains() {
      try {
        let p = await getChain();
        if (p) {
          let tokenState = !!sessionStorage.getItem("token");
          if (tokenState) {
            let addr = await connectWallet();
            if (addr != this.loginAddr) {
              sessionStorage.clear();
              this.$store.commit("SET_ClEAR");
              // if (this.$route.path != "/login") this.$router.push("/login");
            }
          }
        } else {
          sessionStorage.clear();
          this.$store.commit("SET_ClEAR");
          // if (this.$route.path != "/login") this.$router.push("/login");
          setTimeout(() => {
            this.$toast(this.$t("请切换到天晟链"));
          }, 2000);
        }
      } catch (e) {
        console.log(e);
      }
    },
    // 重新加载页面
    getAdapter() {
      let lastWidth = window.innerWidth;
      window.addEventListener(
        "resize",
        _.debounce((e) => {
          // 如果处于全屏模式，直接跳过
          const currentWidth = window.innerWidth;
          if (currentWidth !== lastWidth) {
            setRem();

            if (this.isFullscreen) {
            } else {
              location.reload();
            }
            lastWidth = currentWidth;
          }
        }, 250)
      );
    },
    goHome() {
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.logo_tab_end_draw {

  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.logo_span1 {
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 0.7rem;
  margin: 0px 0.5rem;
}

.logo_tab_flex {
  display: flex;

  align-items: center;
}

.logo_tab {
  font-family: Roboto, Roboto;
  font-weight: 400;

  display: flex;
  align-items: center;


}

.logo_tab_font {
  font-size: 0.7rem;
  color: #555555;
  margin: 0px 0.5rem;
}

.logo_tab_font_active {
  font-size: 0.7rem;
  color: #D4AF37;
  margin: 0px 0.5rem;
}

.logo_lang_img {
  width: 30px;
  height: 30px;
}

.logo_Address {
  width: 5rem;
  text-align: center;
  font-size: 13px;

  padding: 5px 10px;
  border-radius: 1rem;
  background: linear-gradient(270deg, #E6C866 0%, #D4AF37 100%);
  cursor: pointer;
}

#app {
  width: 100%;
  min-height: 100vh;
  background: #fff;
}

.app_M {
  width: 100%;
  height: 100%;
}

.app_P {
  width: 100%;
  // width: var(--global-width);
  height: 100%;
  margin: 0 auto;
}

.app_Ps {
  width: 100%;
  height: 100%;
  margin: 0 auto;
}

.app_header_noLogin_P {
  background: rgba(255, 255, 255, 0.8);
}

.app_header_login_P {
  background: rgba(7, 28, 77, 0);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
}

.app_header_P {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: start;
  align-items: center;

  img {
    width: 1.5rem;
    object-fit: contain;
    cursor: pointer;
  }


  .logo_lang {
    // width: calc(80% - 4rem);
    // width: calc(85% - 4rem);

    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: end;

    position: relative;

    .logo_lang_er {
      font-size: 0.7rem;
      visibility: hidden;
      opacity: 0;
      pointer-events: none;
      transition: visibility 0.2s, opacity 0.2s ease, transform 0.2s ease;

      position: absolute;
      z-index: 999 !important;
      box-shadow: 0 0.095rem 0.95rem 0 rgba(0, 0, 0, 0.05);

      border: 1px solid rgb(230, 227, 227);
      border-radius: 0.5rem;
      text-align: center;
      bottom: -2.7rem;
      background: #fff;
      padding: 0.2rem 0.5rem;
      right: 0rem;
    }
  }

  .logo_lang_right_mb {
    margin-right: -30px;
  }
}
</style>
